import { ColorsEnum } from "../../core/et3-theme/colors";

const ALPHA_TINT = "1A";
const ALPHA_STRONG = "2E";
const ALPHA_HAIRLINE = "1F";
const ALPHA_SHADOW = "0F";

export const ALARM_CARD_WIDTH = 325;
export const ALARM_CARD_HEIGHT = 80;
export const ALARM_CARD_RADIUS = 14;
export const ALARM_CARD_PADDING_X = 16;
export const ALARM_CARD_GAP = 14;

export const ALARM_ACCENT_WIDTH = 3;
export const ALARM_ACCENT_HEIGHT = 44;
export const ALARM_ACCENT_RADIUS = 2;

export const ALARM_ICON_BADGE_SIZE = 38;
export const ALARM_ICON_BADGE_RADIUS = 11;
export const ALARM_ICON_SIZE = 17;

export const ALARM_LABEL_FONT_SIZE = 14;
export const ALARM_VALUE_FONT_SIZE = 22;
export const ALARM_TEXT_GAP = 3;
export const ALARM_LOADER_HEIGHT = 18;
export const ALARM_LOADER_WIDTH = 34;

export const ALARM_CARD_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const ALARM_CARD_SHADOW = `0 1px 3px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW}`;
export const ALARM_DANGER_BADGE = `${ColorsEnum.red}${ALPHA_TINT}`;
export const ALARM_SAFE_BADGE = `${ColorsEnum.green}${ALPHA_TINT}`;
export const ALARM_INFO_BADGE = `${ColorsEnum.bondiBlue}${ALPHA_TINT}`;
export const ALARM_WARN_BADGE = `${ColorsEnum.darkOrange}${ALPHA_TINT}`;

export const ALARM_STATUS_HEIGHT = 24;
export const ALARM_STATUS_RADIUS = 7;
export const ALARM_STATUS_PADDING_X = 9;
export const ALARM_STATUS_GAP = 7;
export const ALARM_STATUS_FONT_SIZE = 13;
export const ALARM_STATUS_DOT_SIZE = 7;
export const ALARM_STATUS_LETTER_SPACING = 0.7;
export const ALARM_SAFE_STATUS_BACKGROUND = `${ColorsEnum.green}${ALPHA_STRONG}`;
export const ALARM_DANGER_CARD_BACKGROUND = `${ColorsEnum.red}${ALPHA_STRONG}`;
export const ALARM_DANGER_CARD_BORDER = `1px solid ${ColorsEnum.red}`;
